/*
 *
 * BookingManagement Actions
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 26-Feb-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_BOOKINGS_SEARCH: '@@BookingManagement/bookings_search',
  DO_BOOKING_DETAIL: '@@BookingManagement/booking_detail',
  DO_RETRIVE_STRUCTURES: '@@BookingManagement/retrive_structures',
  DO_SET_SELECTED_BOOKING: '@@BookingManagement/set_selected_booking',
  DO_RETRIEVE_BOOKING_LOG_ACTIONS: '@@BookingManagement/retrieve_booking_log_actions',
  DO_RETRIEVE_BOOKING_DETAIL_ACTIONS: '@@BookingManagement/retrieve_booking_detail_actions',
  DO_EXECUTE_BOOKING_ACTION: '@@BookingManagement/execute_booking_action',
  DO_EXECUTE_BOOKING_CONSEQUENCE_ACTION: '@@BookingManagement/execute_booking_consequence_action',
  DO_SET_CREATE_BOOKING_STEP: '@@BookingManagement/set_create_booking_step',
  DO_RETRIVE_TACS: '@@BookingManagement/retrive_tacs',
  DO_CREATE_RESERVATION: '@@BookingManagement/create_reservation',
  DO_CREATE_PAY_BY_LINK: '@@BookingManagement/create_pay_by_link',
  DO_SET_CREATE_BOOKING_RESULT: '@@BookingManagement/set_create_booking_result',
  DO_SET_EVENT_TYPE: '@@BookingManagement/set_event_type',
  DO_RETRIVE_RESERVATION_TYPES: '@@BookingManagement/retrive_reservation_types',
  DO_RESET_BOOKINGS: '@@BookingManagement/reset_bookings',
  DO_SET_BOOKING_SOURCE_PAGE: '@@BookingManagement/set_booking_source_page',
  // @generator action:route:type
  ...createRequestTypes('@@BookingManagement', 'FETCH_BOOKINGS'),
  ...createRequestTypes('@@BookingManagement', 'FETCH_BOOKING_DETAIL'),
  ...createRequestTypes('@@BookingManagement', 'GET_STRUCTURES'),
  ...createRequestTypes('@@BookingManagement', 'GET_BOOKING_LOG_ACTIONS'),
  ...createRequestTypes('@@BookingManagement', 'GET_BOOKING_DETAIL_ACTIONS'),
  ...createRequestTypes('@@BookingManagement', 'POST_EXECUTE_BOOKING_ACTION'),
  ...createRequestTypes('@@BookingManagement', 'GET_TACS'),
  ...createRequestTypes('@@BookingManagement', 'POST_CREATE_RESERVATION'),
  ...createRequestTypes('@@BookingManagement', 'GENERATE_PAY_BY_LINK'),
  ...createRequestTypes('@@BookingManagement', 'GET_RESERVATION_TYPES')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name getReservationTypes
 * @return {object} - The action object
 */
export const getReservationTypes = new MakeRequest('BookingManagement', 'get_reservation_types')
/** @action request
 * * Insert a description
 * @name generatePayByLink
 * @return {object} - The action object
 */
export const generatePayByLink = new MakeRequest('BookingManagement', 'generate_pay_by_link')
/** @action request
 * * Insert a description
 * @name postCreateReservation
 * @return {object} - The action object
 */
export const postCreateReservation = new MakeRequest('BookingManagement', 'post_create_reservation')
/** @action request
 * * Insert a description
 * @name getTacs
 * @return {object} - The action object
 */
export const getTacs = new MakeRequest('BookingManagement', 'get_tacs')
/** @action request
 * * Insert a description
 * @name postExecuteBookingAction
 * @return {object} - The action object
 */
export const postExecuteBookingAction = new MakeRequest('BookingManagement', 'post_execute_booking_action')
/** @action request
 * * Insert a description
 * @name getBookingDetailActions
 * @return {object} - The action object
 */
export const getBookingDetailActions = new MakeRequest('BookingManagement', 'get_booking_detail_actions')
/** @action request
 * * Insert a description
 * @name getBookingLogActions
 * @return {object} - The action object
 */
export const getBookingLogActions = new MakeRequest('BookingManagement', 'get_booking_log_actions')
/** @action request
 * * Insert a description
 * @name getStructures
 * @return {object} - The action object
 */
export const getStructures = new MakeRequest('BookingManagement', 'get_structures')
/** @action request
 * * Insert a description
 * @name fetchBookings
 * @return {object} - The action object
 */
export const fetchBookings = new MakeRequest('BookingManagement', 'fetch_bookings')

/** @action request
 * * Insert a description
 * @name fetchBookingDetail
 * @return {object} - The action object
 */
export const fetchBookingDetail = new MakeRequest('BookingManagement', 'fetch_booking_detail')
// @generator action:route
/** @action
 * * Insert a description
 * @name SetBookingSourcePage
 * @return {object} - The payload object
 */
export const doSetBookingSourcePage = (payload) => createAction(actionTypes.DO_SET_BOOKING_SOURCE_PAGE, { payload })
/** @action
 * * Insert a description
 * @name ResetBookings
 * @return {object} - The payload object
 */
export const doResetBookings = (payload) => createAction(actionTypes.DO_RESET_BOOKINGS, { payload })
/** @action
 * * Insert a description
 * @name RetriveReservationTypes
 * @return {object} - The payload object
 */
export const doRetriveReservationTypes = (payload) =>
  createAction(actionTypes.DO_RETRIVE_RESERVATION_TYPES, { payload })
/** @action
 * * Insert a description
 * @name SetEventType
 * @return {object} - The payload object
 */
export const doSetEventType = (payload) => createAction(actionTypes.DO_SET_EVENT_TYPE, { payload })
/** @action
 * * Insert a description
 * @name SetCreateBookingResult
 * @return {object} - The payload object
 */
export const doSetCreateBookingResult = (payload) => createAction(actionTypes.DO_SET_CREATE_BOOKING_RESULT, { payload })
/** @action
 * * Insert a description
 * @name CreatePayByLink
 * @return {object} - The payload object
 */
export const doCreatePayByLink = (payload) => createAction(actionTypes.DO_CREATE_PAY_BY_LINK, { payload })
/** @action
 * * Insert a description
 * @name CreateReservation
 * @return {object} - The payload object
 */
export const doCreateReservation = (payload) => createAction(actionTypes.DO_CREATE_RESERVATION, { payload })
/** @action
 * * Insert a description
 * @name RetriveTacs
 * @return {object} - The payload object
 */
export const doRetriveTacs = (payload) => createAction(actionTypes.DO_RETRIVE_TACS, { payload })
/** @action
 * * Insert a description
 * @name SetCreateBookingStep
 * @return {object} - The payload object
 */
export const doSetCreateBookingStep = (payload) => createAction(actionTypes.DO_SET_CREATE_BOOKING_STEP, { payload })
/** @action
 * * Insert a description
 * @name ExecuteBookingConsequenceAction
 * @return {object} - The payload object
 */
export const doExecuteBookingConsequenceAction = (payload) =>
  createAction(actionTypes.DO_EXECUTE_BOOKING_CONSEQUENCE_ACTION, { payload })
/** @action
 * * Insert a description
 * @name ExecuteBookingAction
 * @return {object} - The payload object
 */
export const doExecuteBookingAction = (payload) => createAction(actionTypes.DO_EXECUTE_BOOKING_ACTION, { payload })
/** @action
 * * Insert a description
 * @name RetrieveBookingDetailActions
 * @return {object} - The payload object
 */
export const doRetrieveBookingDetailActions = (payload) =>
  createAction(actionTypes.DO_RETRIEVE_BOOKING_DETAIL_ACTIONS, { payload })
/** @action
 * * Insert a description
 * @name RetrieveBookingLogActions
 * @return {object} - The payload object
 */
export const doRetrieveBookingLogActions = (payload) =>
  createAction(actionTypes.DO_RETRIEVE_BOOKING_LOG_ACTIONS, { payload })
/** @action
 * * Insert a description
 * @name SetSelectedBooking
 * @return {object} - The payload object
 */
export const doSetSelectedBooking = (payload) => createAction(actionTypes.DO_SET_SELECTED_BOOKING, { payload })
/** @action
 * * Insert a description
 * @name RetriveStructures
 * @return {object} - The payload object
 */
export const doRetriveStructures = (payload) => createAction(actionTypes.DO_RETRIVE_STRUCTURES, { payload })
/** @action
 * * Insert a description
 * @name BookingsSearch
 * @return {object} - The payload object
 */
export const doBookingsSearch = (payload) => createAction(actionTypes.DO_BOOKINGS_SEARCH, { payload })

/** @action
 * * Insert a description
 * @name GetBookingDetail
 * @return {object} - The payload object
 */
export const doGetBookingDetail = (payload) => createAction(actionTypes.DO_BOOKING_DETAIL, { payload })
